var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstructor3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 468 468",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M248.887 467.584c-120.178 7.561-214.46-89.163-240.914-189.005-2.535-9.567-28.506-113.822 29.5-200.36 10.595-15.807 39.252-57.291 90.957-72.26 53.657-15.534 123.959-.148 140.124 39.759 11.362 28.052-10.049 53.351 1.639 65.002 20.069 20.005 83.117-54.659 133.568-37.695 48.421 16.282 72.895 112.816 61.458 187.263C449.99 359.415 364.81 460.29 248.887 467.584z",
    fill: "#000000",
    opacity: 0,
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#e6edff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m.199 225.334 116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 236.057l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 246.779l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.201.201 0 0 1 .199-.199zM.199 257.502l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 268.225l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 278.948l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 289.67l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 300.393l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 311.116l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 321.838l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 332.561l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 343.284l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 354.006l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.201.201 0 0 1 .199-.199zM.199 364.729l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 375.452l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 386.174l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.201.201 0 0 1 .199-.199zM.199 396.398l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.201.201 0 0 1 .199-.199zM.199 406.622l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.201.201 0 0 1 .199-.199zM.199 416.846l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.201.201 0 0 1 .199-.199zM.199 427.07l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 437.294l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 446.496l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 456.72l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-38.967.262-77.935-.184-116.902-.4l-116.902-.6-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 214.611l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8A.201.201 0 0 1 0 214.81a.201.201 0 0 1 .199-.199zM.199 203.889l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 193.166l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 182.443l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 171.721l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 160.998l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 150.275l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 139.552l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.201.201 0 0 1 .199-.199zM.199 128.83l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 118.107l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.2.2 0 0 1 .199-.199zM.199 107.384l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.201.201 0 0 1-.199-.201.201.201 0 0 1 .199-.199zM.199 96.662l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 85.939l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 75.216l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8c-.111 0-.2-.091-.199-.201s.09-.198.199-.199zM.199 64.494l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 53.771l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 43.048l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 32.326l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 21.603l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1l-116.902-.8a.2.2 0 0 1 0-.4zM.199 10.88l116.902-.8c77.922-.4 155.885-1.524 233.804-1 38.967.365 77.935.654 116.902 1.8a.2.2 0 0 1 0 .4c-38.967 1.146-77.935 1.435-116.902 1.8-77.919.524-155.882-.6-233.804-1L.199 11.28a.2.2 0 0 1 0-.4z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#16dba2",
    d: "M367.359 466H238.641c-5.523 0-10-4.477-10-10v-18c0-5.523 4.477-10 10-10h128.718z",
    opacity: 1,
    "data-original": "#16dba2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14c679",
    d: "M238.641 456v-18c0-5.523 4.477-10 10-10h-10c-5.523 0-10 4.477-10 10v18c0 5.523 4.477 10 10 10h10c-5.523 0-10-4.477-10-10z",
    opacity: 1,
    "data-original": "#14c679"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M346 456h-68a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h68z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 447.399,
    r: 7,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd54f",
    d: "M347.359 428H218.641c-5.523 0-10-4.477-10-10v-18c0-5.523 4.477-10 10-10h128.718z",
    opacity: 1,
    "data-original": "#ffd54f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M326 418h-68a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h68z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 409.399,
    r: 7,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M454 310.811H34v-256c0-11.046 8.954-20 20-20h380c11.046 0 20 8.954 20 20z",
    opacity: 1,
    "data-original": "#b0bec5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M48 310.811v-256c0-3.309 2.691-6 6-6h380c3.309 0 6 2.691 6 6v256z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78909c",
    d: "M446 351.811H42c-11.046 0-20-8.954-20-20v-21h444v21c0 11.045-8.954 20-20 20z",
    opacity: 1,
    "data-original": "#78909c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc1b0",
    d: "M411.833 260.508 425 310.811h-39l-9-39.303z",
    opacity: 1,
    "data-original": "#ffc1b0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6666",
    d: "M432 263.008s-5.935-76.242-24.561-100.24c-12.446-11.858-29.172-17.609-46.272-17.427l-27.604-2.76c-29.065-2.906-68.377 7.673-85.676 33.255l-36.054 53.319 34 41.02 24.099-34.787c.836 4.502 1.695 9.011 2.568 13.454 7.667 39-9 61.969-9 61.969h124.333c-1.552-4.969-2.565-10.502-3.149-16.416z",
    opacity: 1,
    "data-original": "#ff6666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e55c5c",
    d: "M318 142.286c-26.24 1.431-55.756 12.319-70.112 33.551l-36.054 53.319 5.733 6.916 35.321-52.235c13.451-19.892 40.209-30.708 65.112-33.172z",
    opacity: 1,
    "data-original": "#e55c5c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.5,
    cy: 113.008,
    r: 43,
    fill: "#4c4c4c",
    opacity: 1,
    "data-original": "#4c4c4c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e55c5c",
    d: "M389.23 243.082a1.999 1.999 0 1 0-3.954-.605c-4.56 29.759-4.525 52.354.465 68.334h4.3c-4.807-15.393-5.278-38.577-.811-67.729z",
    opacity: 1,
    "data-original": "#e55c5c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc1b0",
    d: "m361.167 144.341-4.355-.435c-11.236-11.276-14.59-30.157-13.645-47.731l-34.667 9.333s8.515 19.273 3.224 35.657c-6.987.883-12.933 1.522-21.624 4.973 2.016 12.659 7.141 29.544 34.733 26.704 21.435-2.207 36.986-13.828 48.914-27.091-7.811-1.342-12.58-1.41-12.58-1.41z",
    opacity: 1,
    "data-original": "#ffc1b0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffac99",
    d: "M308.5 105.508s8.515 19.273 3.224 35.657c-6.987.883-12.933 1.522-21.624 4.973 1.522 9.556 4.822 21.515 18.215 25.584-6.083-5.532-8.116-13.683-9.215-20.584 8.69-3.451 14.636-4.09 21.624-4.973 5.292-16.383-3.224-35.657-3.224-35.657l25.543-6.877c-.047-2.495-.009-4.988.123-7.456z",
    opacity: 1,
    "data-original": "#ffac99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd7cc",
    d: "M332.833 127.175s-26.667 7.333-36-26.667-1.201-51.188 4-55.667c12-10.333 48.333-8.667 54.333 36 5.961 44.369-22.333 46.334-22.333 46.334z",
    opacity: 1,
    "data-original": "#ffd7cc",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c4c4c",
    d: "M300.833 44.841S348 45.508 347 74.508s-.57 62.887 12 77c9.059 10.171-1.431 52.164-7.998 74.831-2.336 8.063 4.093 15.953 12.463 15.316 15.403-1.171 36.373-7.803 40.824-34.459C411.5 164.008 375.5 145.508 375 111.008s-21-88.5-56.5-89-17.667 22.833-17.667 22.833z",
    opacity: 1,
    "data-original": "#4c4c4c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c4c4c",
    d: "M300.5 30.508s-26.667-9-23.333 63c3.333 72-38.667 98.097-10.167 139.548 6.583 7.234 16.757 11.637 25.111 14.211 7.374 2.272 14.953-2.905 15.5-10.602 1.569-22.111 2.901-66.396-7.61-100.658-3.525-11.489-3.167-35.5-4-43.5-1.966-18.874 19.44-16.5 8-44.5z",
    opacity: 1,
    "data-original": "#4c4c4c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3f3f",
    d: "M277 233.056c-28.5-41.452 13.5-67.548 10.167-139.548-1.957-42.268 6.425-56.615 13.681-61.261l-.348-1.739s-26.667-9-23.333 63c3.333 72-38.667 98.097-10.167 139.548 6.583 7.234 16.757 11.637 25.111 14.211a11.9 11.9 0 0 0 8.395-.511c-8.022-2.631-17.339-6.923-23.506-13.7z",
    opacity: 1,
    "data-original": "#3f3f3f",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.1,
    cy: 294.439,
    r: 5,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.1,
    cy: 274.439,
    r: 5,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.1,
    cy: 234.439,
    r: 5,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.1,
    cy: 264.439,
    r: 5,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.1,
    cy: 229.439,
    r: 5,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335.1,
    cy: 189.439,
    r: 5,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.1,
    cy: 249.439,
    r: 5,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc1b0",
    d: "M226.313 127.5c2.701 4.557 4.811 10.831 4.687 19.258l1.128-2.35c1.764-3.673 6.928-3.852 8.941-.309.79 1.39.875 3.071.229 4.534l-6.798 15.375-7 11.833c1.227 25.289 3.207 50.683 3.173 76.01l15.159 18.289s-29.805 35.034-46.332 16.701c-13.897-15.416 2.333-113.333 2.333-113.333-6.585-13.812-7.314-32.023.185-45.548 5.245-9.459 18.78-9.765 24.295-.46z",
    opacity: 1,
    "data-original": "#ffc1b0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd7cc",
    d: "M100.341 258.494s-20.643-28.989-30.657-15.96c-10.493 13.654 30.657 31.919 30.657 31.919zM145.971 258.494s20.643-28.989 30.657-15.96c10.493 13.654-30.657 31.919-30.657 31.919z",
    opacity: 1,
    "data-original": "#ffd7cc",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc1b0",
    d: "m203.663 422.338-19.108-41.596 31.008-7.835s7.084 15 9.415 19.706c28.759 58.048-5.328 58.721-17.463 56.589-8.643-1.518-47.826-14.833-47.826-14.833v-17.786zM19.23 257.511s1.359 34.124 4.097 63.043l24.573 1.165c-.446-3.073.817-9.196-.469-15.954l-5.005-49.391 4.762-11.437 4.138-14.57a4.552 4.552 0 0 0-.772-4.02c-2.241-2.909-6.827-2.102-7.94 1.397l-.712 2.239c-2.545-20.267-16.811-19.256-16.811-19.256-7.303.913-14.19 10.184-13.585 23.12.709 15.166 7.724 23.664 7.724 23.664z",
    opacity: 1,
    "data-original": "#ffc1b0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6184f2",
    d: "M175.674 316.207c-28.105-19.126-79.323-18.343-108.239 5.153-5.635 4.579-9.765 10.747-12.048 17.64l-6.729-41.949-27.508 8.998 2.458 50.99c.607 12.594 12.574 21.491 24.809 18.445l16.553-4.121V456h115.586v-81.258l13.19 26.005 25.906-19.897c-11.688-23.517-22.021-49.701-43.978-64.643z",
    opacity: 1,
    "data-original": "#6184f2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6262ef",
    d: "m33.608 357.038-2.659-54.195-9.799 3.205 2.458 50.99c.607 12.594 12.574 21.491 24.809 18.445l.158-.04c-8.136-2.115-14.528-9.289-14.967-18.405zM64.97 373.851V456h10v-84.638z",
    opacity: 1,
    "data-original": "#6262ef"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85a6f9",
    d: "M180.555 456h-80.214l80.214-67.746z",
    opacity: 1,
    "data-original": "#85a6f9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcdbd",
    d: "M104.555 300.087V253h36.818v45.88c0 2.903 2.084 5.357 4.935 5.903a94.517 94.517 0 0 1 10.038 2.483c-6.768 11.364-19.158 18.99-33.345 18.99-13.581 0-25.51-6.992-32.443-17.557a95.48 95.48 0 0 1 9.348-2.767c2.715-.658 4.649-3.052 4.649-5.845z",
    opacity: 1,
    "data-original": "#ffcdbd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c4c4c",
    d: "M168.915 202.864c0-7.732-6.268-14-14-14H109.46c-15.445 0-27.966 12.521-27.966 27.966 0 2.067.231 4.08.657 6.02-2.738 6.485-4.276 13.726-4.276 21.369 0 27.735 20.156 50.219 45.021 50.219 24.864 0 45.021-22.484 45.021-50.219 0-7.558-1.506-14.72-4.187-21.149a41.74 41.74 0 0 0 5.185-20.206z",
    opacity: 1,
    "data-original": "#4c4c4c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3f3f",
    d: "M87.874 244.219c0-7.644 1.538-14.884 4.276-21.369a28.028 28.028 0 0 1-.657-6.02c0-15.445 12.521-27.966 27.966-27.966h-10c-15.445 0-27.966 12.521-27.966 27.966 0 2.067.231 4.08.657 6.02-2.738 6.485-4.276 13.726-4.276 21.369 0 27.735 20.156 50.219 45.021 50.219 1.691 0 3.358-.113 5-.316-22.51-2.775-40.021-24.053-40.021-49.903z",
    opacity: 1,
    "data-original": "#3f3f3f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16dba2",
    d: "M198 0H64a6 6 0 0 0-6 6v62.443a6 6 0 0 0 6 6h97.133l21.237 17.083.078-17.083H198a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6z",
    opacity: 1,
    "data-original": "#16dba2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14c679",
    d: "M74 0H64a6 6 0 0 0-6 6v62.443a6 6 0 0 0 6 6h10a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z",
    opacity: 1,
    "data-original": "#14c679"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M178.7 24.093H83.3a2 2 0 0 1 0-4h95.4a2 2 0 0 1 0 4zM146.961 52.31H83.3a2 2 0 0 1 0-4h63.661a2 2 0 0 1 0 4z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd54f",
    d: "M120 100H6a6 6 0 0 0-6 6v54.443a6 6 0 0 0 6 6h77.133l21.237 17.083.078-17.083H120a6 6 0 0 0 6-6V106a6 6 0 0 0-6-6z",
    opacity: 1,
    "data-original": "#ffd54f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9852",
    d: "M16 100H6a6 6 0 0 0-6 6v54.443a6 6 0 0 0 6 6h10a6 6 0 0 1-6-6V106a6 6 0 0 1 6-6z",
    opacity: 1,
    "data-original": "#ff9852"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M95.41 122.093h-75.4a2 2 0 0 1 0-4h75.4a2 2 0 0 1 0 4zM63.671 146.31H20.01a2 2 0 0 1 0-4h43.661a2 2 0 0 1 0 4z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "m402.698 426.401 23.509 22.997-8.162-31.858c-6.723-26.24-20.296-50.285-39.587-69.3-7.23-7.126-13.667-11.962-16.587-10.276s-1.951 9.678.605 19.503c6.821 26.215 20.858 49.992 40.222 68.934z",
    opacity: 1,
    "data-original": "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aaaaaa",
    d: "M418.899 438.738a1.998 1.998 0 0 1-1.734-1l-44.118-76.414a2 2 0 1 1 3.464-2l44.118 76.414a2 2 0 0 1-1.73 3z",
    opacity: 1,
    "data-original": "#aaaaaa"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "m425.379 426.401-23.509 22.997 8.162-31.858c6.722-26.24 20.296-50.285 39.587-69.3 7.23-7.126 13.667-11.962 16.588-10.276s1.951 9.678-.605 19.503c-6.822 26.215-20.859 49.992-40.223 68.934z",
    opacity: 1,
    "data-original": "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aaaaaa",
    d: "M409.178 438.738a2 2 0 0 1-1.73-3l44.118-76.414a2 2 0 1 1 3.464 2l-44.118 76.414c-.37.642-1.043 1-1.734 1z",
    opacity: 1,
    "data-original": "#aaaaaa"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6d6d6",
    d: "m405.178 416.347 8.861 31.671 8.861-31.671c7.298-26.086 7.566-53.696.367-79.81-2.698-9.787-5.854-17.193-9.227-17.193s-6.529 7.406-9.227 17.193c-7.202 26.114-6.934 53.724.365 79.81z",
    opacity: 1,
    "data-original": "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "M414.039 435.399a2 2 0 0 1-2-2v-88.235a2 2 0 0 1 4 0v88.235a2 2 0 0 1-2 2z",
    opacity: 1,
    "data-original": "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff669d",
    d: "M401.235 468h25.606c4.766 0 8.87-3.364 9.806-8.037l8.391-41.926h-62l8.391 41.926a10.001 10.001 0 0 0 9.806 8.037z",
    opacity: 1,
    "data-original": "#ff669d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef508d",
    d: "m401.43 459.963-8.391-41.926h-10l8.391 41.926a9.999 9.999 0 0 0 9.805 8.037h10a10 10 0 0 1-9.805-8.037z",
    opacity: 1,
    "data-original": "#ef508d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f47db3",
    d: "M450.039 420.036h-72a2 2 0 0 1 0-4h72a2 2 0 0 1 0 4z",
    opacity: 1,
    "data-original": "#f47db3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructor3);
export default __webpack_public_path__ + "static/media/instructor-3.519f2ce5747e43ef28042d2a5726b3d3.svg";
export { ForwardRef as ReactComponent };